module.exports = __webpack_public_path__ + "fonts/f4f638d0cbf629e67fa9c355daa47347.woff";